const TokenTuple = {
  components: [
    { internalType: 'address', name: 'token', type: 'address' },
    { internalType: 'uint256', name: 'decimals', type: 'uint256' },
    { internalType: 'string', name: 'symbol', type: 'string' },
    { internalType: 'string', name: 'name', type: 'string' },
  ],
  internalType: 'struct Token',
  name: 'underlying',
  type: 'tuple',
} as const

/** Regular BENQI MarketMetadata (no supplyCap, fixed reward speed fields) */
const BenqiMarketMetadataTuple = {
  components: [
    { internalType: 'address', name: 'market', type: 'address' },
    { internalType: 'uint256', name: 'supplyRate', type: 'uint256' },
    { internalType: 'uint256', name: 'borrowRate', type: 'uint256' },
    { internalType: 'uint256', name: 'price', type: 'uint256' },
    { internalType: 'uint256', name: 'exchangeRate', type: 'uint256' },
    { internalType: 'uint256', name: 'reserveFactor', type: 'uint256' },
    { internalType: 'uint256', name: 'borrowCap', type: 'uint256' },
    { internalType: 'uint256', name: 'totalSupply', type: 'uint256' },
    {
      internalType: 'uint256',
      name: 'totalUnderlyingSupply',
      type: 'uint256',
    },
    { internalType: 'uint256', name: 'totalBorrows', type: 'uint256' },
    { internalType: 'uint256', name: 'collateralFactor', type: 'uint256' },
    TokenTuple,
    { internalType: 'uint256', name: 'qiTokenDecimals', type: 'uint256' },
    {
      internalType: 'uint256',
      name: 'avaxSupplyRewardSpeed',
      type: 'uint256',
    },
    {
      internalType: 'uint256',
      name: 'avaxBorrowRewardSpeed',
      type: 'uint256',
    },
    {
      internalType: 'uint256',
      name: 'qiSupplyRewardSpeed',
      type: 'uint256',
    },
    {
      internalType: 'uint256',
      name: 'qiBorrowRewardSpeed',
      type: 'uint256',
    },
    { internalType: 'uint256', name: 'totalReserves', type: 'uint256' },
    { internalType: 'uint256', name: 'cash', type: 'uint256' },
    { internalType: 'bool', name: 'mintPaused', type: 'bool' },
    { internalType: 'bool', name: 'borrowPaused', type: 'bool' },
  ],
  internalType: 'struct MarketMetadata',
  name: '',
  type: 'tuple',
} as const

const RewardEmissionTuple = {
  components: [
    TokenTuple,
    { internalType: 'uint256', name: 'endTime', type: 'uint256' },
    {
      internalType: 'uint256',
      name: 'supplyEmissionsPerSec',
      type: 'uint256',
    },
    {
      internalType: 'uint256',
      name: 'borrowEmissionsPerSec',
      type: 'uint256',
    },
  ],
  internalType: 'struct RewardEmission',
  name: '',
  type: 'tuple',
} as const

/** Ecosystem BENQI MarketMetadata (has supplyCap + dynamic rewards) */
const BenqiEcoMarketMetadataTuple = {
  components: [
    { internalType: 'address', name: 'market', type: 'address' },
    { internalType: 'uint256', name: 'supplyRate', type: 'uint256' },
    { internalType: 'uint256', name: 'borrowRate', type: 'uint256' },
    { internalType: 'uint256', name: 'price', type: 'uint256' },
    { internalType: 'uint256', name: 'exchangeRate', type: 'uint256' },
    { internalType: 'uint256', name: 'reserveFactor', type: 'uint256' },
    { internalType: 'uint256', name: 'borrowCap', type: 'uint256' },
    { internalType: 'uint256', name: 'supplyCap', type: 'uint256' },
    { internalType: 'uint256', name: 'totalSupply', type: 'uint256' },
    {
      internalType: 'uint256',
      name: 'totalUnderlyingSupply',
      type: 'uint256',
    },
    { internalType: 'uint256', name: 'totalBorrows', type: 'uint256' },
    { internalType: 'uint256', name: 'collateralFactor', type: 'uint256' },
    TokenTuple,
    { internalType: 'uint256', name: 'qiTokenDecimals', type: 'uint256' },
    { internalType: 'uint256', name: 'totalReserves', type: 'uint256' },
    { internalType: 'uint256', name: 'cash', type: 'uint256' },
    { internalType: 'bool', name: 'mintPaused', type: 'bool' },
    { internalType: 'bool', name: 'borrowPaused', type: 'bool' },
    {
      components: RewardEmissionTuple.components,
      internalType: 'struct RewardEmission[]',
      name: 'rewards',
      type: 'tuple[]',
    },
  ],
  internalType: 'struct MarketMetadata',
  name: '',
  type: 'tuple',
} as const

export const BenqiLensAbi = [
  {
    inputs: [],
    name: 'getMarketMetadataForAllMarkets',
    outputs: [
      {
        components: BenqiMarketMetadataTuple.components,
        internalType: 'struct MarketMetadata[]',
        name: '',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
] as const

export const BenqiEcoLensAbi = [
  {
    inputs: [],
    name: 'getMarketMetadataForAllMarkets',
    outputs: [
      {
        components: BenqiEcoMarketMetadataTuple.components,
        internalType: 'struct MarketMetadata[]',
        name: '',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
] as const
